import { render, staticRenderFns } from "./AssessmentDone.vue?vue&type=template&id=73c5c49a"
import script from "./AssessmentDone.vue?vue&type=script&lang=js"
export * from "./AssessmentDone.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports